/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostVariationWidgetConfiguration extends models.BaseCostTrendWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("CostVariationWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return CostVariationWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<CostVariationWidgetConfiguration>): CostVariationWidgetConfiguration {
        let obj = Object.assign(new CostVariationWidgetConfiguration(), model);
        CostVariationWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostVariationWidgetConfiguration>): CostVariationWidgetConfiguration {
        if (!model) return null;
        return CostVariationWidgetConfiguration.newInstance(<CostVariationWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostVariationWidgetConfiguration) {
        if (!obj) return;

        models.CostVariationWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostVariationWidgetConfiguration): boolean {
        if (models.BaseCostTrendWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostVariationWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
